import * as api from "../api";

export const _blank = (_blank) => async (dispatch) => {
    try {
        
    } catch (error) {
        
    }
}